module.exports = __webpack_public_path__ + "static/dcg-e59180c353f2c9e657def670cf98fadc.png";